import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoMdCalendar, IoMdDoneAll, IoMdDownload, IoIosClose } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
import moment from 'moment'
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const SalesOrderPage = () => {
    const fileName = 'Sales Order';
    const [startDate, setStartDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [endDate, setEndDate] = useState(new Date().setHours(0, 0, 0, 0))
    const [salesOrder, setSalesOrder] = useState([])
    const [loading, setLoading] = useState(false)
    const [salesOrderList, setSalesOrderList] = useState([])
    const [childColumns, setChildColumns] = useState([])
    const [modalShow, setModalShow] = useState(false)
    const [salesList, setSalesList] = useState([])
    let filterStartDate = moment(startDate).format("L")
    let filterEndDate = moment(endDate).format("L")
    const [validated, setValidated] = useState(false)
    const [btnDisable, setBtnDisable] = useState(true)
    const [greaterErr, setGreaterErr] = useState(false)
    const [emptyErr, setEmptyErr] = useState(false)
    const [newColumns, setnewColumns] = useState([]);
    const [hasError, setHasError] = useState(false);
    const submitHandler = (e) => {
        e.preventDefault()
        const form = e.currentTarget;
        if (form.checkValidity() === false) {
            e.preventDefault()
            e.stopPropagation()
        } else {
            e.preventDefault()
            if (startDate > endDate) {
                setGreaterErr(true)
                return false
            } else if (startDate < endDate) {
                setGreaterErr(false)
            } else {
                setGreaterErr(false)
            }

            if (startDate === 0) {
                setEmptyErr(true)
                return false
            }

            filterStartDate = moment(startDate).format("L")
            filterEndDate = moment(endDate).format("L")


            getSalesOrder()
            setBtnDisable(true)
        }
        setValidated(true)
    }

    const columns = [
        {
            Header: "Order ID",
            accessor: "SalesOrderNumberID",
            filter: "SalesOrderNumberID",
            sortType: "basic",
            Cell: ({ row: { original } }) => (
                <Button variant="link" onClick={() => getChildRecords(original.SalesOrderNumberID)} className="grid-action-btn">{original.SalesOrderNumberID}</Button>
            )
        },
        {
            Header: "Bill To Name",
            accessor: "BillToName",
            filter: "BillToName",
            sortType: "basic",
            width: 300
        },
        {
            Header: "Bill To ID",
            accessor: "BillToID",
            filter: "BillToID",
            sortType: "basic",
        },

        {
            Header: "Bill To Address Line1",
            accessor: "BillToAddressLine1",
            filter: "BillToAddressLine1",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Bill To Address Line2",
            accessor: "BillToAddressLine2",
            filter: "BillToAddressLine2",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Bill To City",
            accessor: "BillToCity",
            filter: "BillToCity",
            sortType: "basic",
        },
        {
            Header: "Bill To State",
            accessor: "BillToState",
            filter: "BillToState",
            sortType: "basic",
        },
        {
            Header: "Bill To Zip Code",
            accessor: "BillToZipCode",
            filter: "BillToZipCode",
            sortType: "basic",
        },
        {
            Header: "Bill To Country",
            accessor: "BillToCountry",
            filter: "BillToCountry",
            sortType: "basic",
        },
        {
            Header: "Ship To ID",
            accessor: "ShipToID",
            filter: "ShipToID",
            sortType: "basic",
        },
        {
            Header: "Ship To Name",
            accessor: "ShipToName",
            filter: "ShipToName",
            sortType: "basic",
            width: 300
        },
        {
            Header: "Ship To Address Line1",
            accessor: "ShipToAddressLine1",
            filter: "ShipToAddressLine1",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Ship To Address Line2",
            accessor: "ShipToAddressLine2",
            filter: "ShipToAddressLine2",
            sortType: "basic",
            width: 180
        },
        {
            Header: "Ship To City",
            accessor: "ShipToCity",
            filter: "ShipToCity",
            sortType: "basic",
        },
        {
            Header: "Ship To State",
            accessor: "ShipToState",
            filter: "ShipToState",
            sortType: "basic",
        },
        {
            Header: "Ship To Zip Code",
            accessor: "ShipToZipCode",
            filter: "ShipToZipCode",
            sortType: "basic",
        },
        {
            Header: "Ship To Country",
            accessor: "ShipToCountry",
            filter: "ShipToCountry",
            sortType: "basic",
        },
        {
            Header: "Order Date",
            accessor: "SoldDate",
            filter: "SoldDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Order Reference",
            accessor: "Reference",
            filter: "Reference",
            sortType: "basic",
        },
        {
            Header: "Order Status",
            accessor: "Status",
            filter: "Status",
            sortType: "basic",
        },
        {
            Header: "Shipping Cost",
            accessor: "ShippingCost",
            filter: "ShippingCost",
            sortType: "basic",
        },
        {
            Header: "Discount",
            accessor: "Discount",
            filter: "Discount",
            sortType: "basic",
        },
        {
            Header: "Order Total",
            accessor: "SalesTotal",
            filter: "SalesTotal",
            sortType: "basic",
        },
        {
            Header: "SKU",
            accessor: "SKU",
            filter: "SKU",
            sortType: "basic",
        },
        {
            Header: "NDC",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
        },
        {
            Header: "Product",
            accessor: "ProductName",
            filter: "ProductName",
            sortType: "basic",
            width: 300
        },
        {
            Header: "Price",
            accessor: "UnitPrice",
            filter: "UnitPrice",
            sortType: "basic",
        },
        {
            Header: "Total",
            accessor: "SalesTotal",
            filter: "SalesTotal",
            sortType: "basic",
        },
        {
            Header: "Manufacturer ID",
            accessor: "ManufacturerID",
            filter: "ManufacturerID",
            sortType: "basic",
        },
        {
            Header: "Manufacturer Name",
            accessor: "ManufacturerName",
            filter: "ManufacturerName",
            sortType: "basic",

        },
        {
            Header: "Email Id",
            accessor: "Email",
            filter: "Email",
            sortType: "basic",

        },

        {
            Header: "Received Date",
            accessor: "ReceivedDate",
            filter: "ReceivedDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        }
    ];
    const gridColumns = [
        {
            Header: "Order ID",
            accessor: "SalesOrderNumberID",
            filter: "SalesOrderNumberID",
            sortType: "basic",
        },
        {
            Header: "SKU",
            accessor: "SKU",
            filter: "SKU",
            sortType: "basic",
        },
        {
            Header: "NDC",
            accessor: "NDC",
            filter: "NDC",
            sortType: "basic",
        },
        {
            Header: "Product",
            accessor: "ProductName",
            filter: "ProductName",
            sortType: "basic",
            width: 300
        },
        {
            Header: "Quantity",
            accessor: "Quantity",
            filter: "Quantity",
            sortType: "basic",
        },
        {
            Header: "Price",
            accessor: "UnitPrice",
            filter: "UnitPrice",
            sortType: "basic",
        },
        {
            Header: "Total",
            accessor: "TotalSaleItem",
            filter: "TotalSaleItem",
            sortType: "basic",
        },

    ]

    useEffect(() => {
        getSalesOrder()
    }, []);

    // Get Child List
    const handleClose = () => {
        setSalesOrderList([])
        return setModalShow(false)
    }
    const getChildRecords = async (id) => {
        setLoading(true)
        setModalShow(true)
        await _HttpServices
            .getData(`Api/inbound/SalesOrderItem?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=${id}`)
            .then((data) => {
                const response = data.data;
                if (response.length > 0) {
                    response.map((res) => {
                        res.TotalSaleItem = res.TotalSaleItem == null ? "$0.00" : "$" + (res.TotalSaleItem * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.UnitPrice = res.UnitPrice == null ? "$0.00" : "$" + (res.UnitPrice * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                    })
                }
                setSalesOrderList(response)
                setLoading(false)
            })
            .catch((e) => {
                setLoading(false)
                console.log(e)
                setValidated(false);
                setHasError(true);
            });
    }

    async function getSalesOrder() {
        const deletion = ["SKU", "NDC", "Product", "Price", "Total"]
        let removedColumns = columns.slice(0)
        deletion.filter(dt => {
            removedColumns.filter((data, i) => {
                if (data.Header === dt) {
                    removedColumns.splice(i, 1)
                }
            })
        })
        setnewColumns(removedColumns);
        setLoading(true)
        await _HttpServices
            .getData(`Api/inbound/SalesOrderItem?_startDate=${filterStartDate}&_endDate=${filterEndDate}&Id=-1`)
            .then((data) => {
                const response = data.data
                if (response.length > 0) {
                    response.map((res) => {
                        res.ReceivedDate = moment(res.ReceivedDate).format('MM/DD/YYYY');
                        res.SoldDate = moment(res.SoldDate).format('MM/DD/YYYY');
                        res.UnitPrice = res.UnitPrice == null ? "$0.00" : "$" + (res.UnitPrice * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.ShippingCost = res.ShippingCost == null ? "$0.00" : "$" + (res.ShippingCost * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.Discount = res.Discount == null ? "$0.00" : "$" + (res.Discount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.SalesTotal = res.SalesTotal == null ? "$0.00" : "$" + (res.SalesTotal * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.TotalSaleItem = res.TotalSaleItem == null ? "$0.00" : "$" + (res.TotalSaleItem * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

                    })
                }
                const uniqData = Array.from(new Set(response.map(a => a.SalesOrderNumberID)))
                    .map(id => {
                        return response.find(a => a.SalesOrderNumberID === id)
                    })

                const salesOrderResult = uniqData
                setSalesList(response)
                setSalesOrder(salesOrderResult)
                setValidated(false)
                setValidated(false)
                setLoading(false);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                setValidated(false);
                setHasError(true);
            });
    }
    return (
        <section className="content">

            {/* Modal */}
            <Modal show={modalShow} onHide={handleClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Sales Order List</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {hasError ? <p>Error occurred. Unable to load sales order.</p> :
                        <Fragment>
                            {salesOrderList.length > 0 ? (
                                <ReactTable columns={gridColumns} data={salesOrderList} defaultPageSize={10} />
                            ) : (
                                    <div className="no-data">No data found.</div>
                                )}
                        </Fragment>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" onClick={handleClose}><IoIosClose className="icon btn-icon" />Close</Button>
                </Modal.Footer>
            </Modal>

            <div className="page-title">
                <h2 className="h2">Sales Order</h2>
                {loading ? <Loader /> : null}
                {salesOrder.length > 0 ? <Button type="submit" onClick={() => getExcel(columns, salesList, fileName)}><IoMdDownload className="icon btn-icon" />Download Excel</Button> : null}
            </div>

            <Row>

                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <Form noValidate validated={validated} onSubmit={submitHandler}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="StartDate">
                                                    Since
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={startDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setStartDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setGreaterErr(false)
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className={greaterErr ? "form-control is-invalid" : "form-control"}
                                                />
                                                {emptyErr ? <div className="err-feedback">Please select Start Date.</div> : null}
                                                {greaterErr ? <div className="err-feedback">Since should not be greater than until date.</div> : null}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group>
                                            <div className="date-picker ungroup-date-picker pos-rl">
                                                <Form.Label htmlFor="EndDate">
                                                    Until
                                                </Form.Label>
                                                <IoMdCalendar className="icon date-icon" />
                                                <DatePicker
                                                    selected={endDate}
                                                    onChange={(date) => {
                                                        setBtnDisable(false)
                                                        return setEndDate(date)
                                                    }}
                                                    onSelect={(date) => {
                                                        setBtnDisable(false)
                                                    }}
                                                    maxDate={new Date()}
                                                    required className="form-control"
                                                />
                                                <Form.Control.Feedback type="invalid">Please select End Date.</Form.Control.Feedback>
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col md={3}>
                                        <Form.Group className="mt-2">
                                            <Button type="submit" className="mt-3" disabled={btnDisable}>
                                                <IoMdDoneAll className="icon btn-icon" />Submit</Button>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                    </div>

                    <div className="card pt-2">
                        <div className="card-body">
                            <div className="inventory-grid">
                                {hasError ? <p>Error occurred. Unable to load sales order.</p> :
                                    <Fragment>
                                        {salesOrder.length > 0 ? (
                                            <ReactTable columns={newColumns} data={salesOrder} defaultPageSize={10} />
                                        ) : (
                                                <div className="no-data">No data found.</div>
                                            )}
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

            <Footer />
        </section>
    );
}
export default SalesOrderPage;